let _ = require("underscore");
let Backbone = require("backbone");
let BillModel = require("./BillModel.js");
let BillCollection = require("../collection/BillCollection.js");
let tables = require("../collection/TableCollection.js");
let i18n = require("../utils/i18n");
let DbRecorder = require("../recorder/DbRecorder.js");
let moment = require("moment");
let { uuid } = require("../utils/utils.js");

let main = function (_, Backbone, BillModel, BillCollection, tables, i18n, DbRecorder, moment) {
    return Backbone.Model.extend({
        defaults: {
            currentBill: null,
            bills: null,
            billsVersionTotal: 0
        },

        /*
         * 初始化餐台
         */
        initialize: function (params) {
            params = params || {};
            var key = "model/TableModel:" + params.id;
            var currentBill;
            var localBills = [];
            var storage = DbRecorder.read(key);
            if (params.id && storage) {
                //取出localstorage中的bills数据
                localBills = storage.bills || [];
                delete storage.bills;
                //从Storage中取出餐台对应的初始化参数
                params = DbRecorder.defaults(params, storage);
            }
            //设置currentBill
            if (params.currentBill) {
                currentBill = params.currentBill;
            }

            //循环所有的localBills，去掉未保存的、和currentBill相同的和Completed状态的bill
            for (var i = 0; i < localBills.length; i++) {
                //如果没有id， 则放到未保存得bill集合中
                if (localBills[i].status == 'Completed') {
                    // bill都已经completed，就没必要保留在localBills了
                    localBills.splice(i--, 1);
                } else if (currentBill && currentBill.id && currentBill.id == localBills[i].id) {
                    // current bill就是那个local bill，不需要保留在local bill上，这个会特别处理。
                    localBills.splice(i--, 1);
                }
            }



            //设置currentBill
            /** if (currentBill && !(currentBill.status == "Completed"|| currentBill.shouldComplete) && !currentPaid && currentBill.payDate==0) {
                this.set({
                    currentBill: new BillModel(params.currentBill)
                });
            } else {
                this.set({
                    currentBill: new BillModel()
                });
            } */

            if (currentBill && currentBill.status == 'Queue' &&
                ((currentBill.items && currentBill.items.length > 0))) {
                this.set({
                    currentBill: new BillModel(currentBill)
                });
            } else {
                this.set({
                    currentBill: new BillModel()
                });
            }
            this.set({bills: new BillCollection(localBills)});


            this.refreshBillVersionTotal();

            //监听TableModel的变化，并随时记录到localStorage
            DbRecorder.recordChange(key, this);


            this.on("change:currentBill", () => {
                console.log("currentBill changed on table: " + this.get('name'), this.get("currentBill").id);
            });
        },

        refreshBillVersionTotal: function () {
            var total = 0;
            this.getBillCollection().forEach(function(bill) {
                total += (bill.get('version') + 1) || 0;
            });
            this.set({billsVersionTotal: total});
        },

        /*
         * 根据订单信息，设置餐台当前状态
         */
        refreshStatus: function () {
            var isEmpty = (this.getActiveBillCollection().length == 0);  //餐桌上没有订单
            var unpaid = this.getActiveBillCollection().any(function (bill) {
                return !bill.hasPaid()
            });   //餐桌上又未完成订单

            const currentStatus = this.get('status');

            if (unpaid) {
                this.set("status", "Unpaid");
            } else if (isEmpty) {
                if (this.get("status") == "Closed") {
                    this.set("status", "Closed");
                } else {
                    this.set("status", "Empty");
                }
            } else {
                if (currentStatus !== 'Paid') {
                    this.set("status", "Paid");
                }
            }

            if (this.get("status") == "Closed") {
                this.set("statusCode", "pos.status.table." + this.get("status").toLowerCase())
            } else {
                this.set("statusCode", "pos.status." + this.get("status").toLowerCase())
            }

        },

        /*
         * 执行清台
         */
        close: function () {        //  /apiTable/closeTable
            var deferred = $.Deferred();
            if (!this.canClose()) {
                deferred.reject();

            } else {
                this.getActiveBillCollection().forEach(function (bill) {
                    if (!bill.isCanceled()) {
                        bill.pleaseComplete();
                    }
                });
                this.set("status", "Closed");
                deferred.resolve();
            }
            return deferred;
        },

        /*
         * 创建新的currentBill
         */
        createNewBill: function () {
            var currentBill = this.getCurrentBill();
            if (currentBill.getBillItems().length > 0) {
                this.getBillCollection().add(currentBill);
            }
            this.set("currentBill", new BillModel());
        },

        canClose: function () {
            var activeBills = this.getActiveBillCollection(), canClose;
            canClose = activeBills.every(function (bill) {
                return bill.isPaid() || bill.isCanceled();
            });
            if (this.isWebTable()) {
                canClose = canClose && activeBills.every(function (bill) {
                    return bill.isConfirmed()
                });
            }
            return canClose && activeBills.length > 0;
        },

        isEmpty: function () {
            return this.getActiveBillCollection().length === 0;
        },

        /*
         * 转台
         */
        "switch": function (targetTableId, fromTable) {
            var targetTable = tables.get(targetTableId);
            var deferred = $.Deferred();
            var bill = this.getActiveBillCollection().get({cid: $('.bill-list .active a').data('cid')});
            if (targetTable == fromTable) {
                return deferred;
            }
            if (!this.billCanSwitch(bill)) {
                deferred.reject({message: i18n.msg("pos.table.item.refund.error.nullbill")});
            } else if (targetTable == null) {
                deferred.reject({message: i18n.msg("pos.table.item.refund.error.nulltarget")});
            } else if (targetTable.isWebTable()) {
                deferred.reject({message: i18n.msg("pos.table.item.refund.error.takeout")});
            } else {
                if (bill) {
                    console.log("move active bill to another ", bill);
                    this.getBillCollection().remove(bill);
                    targetTable.getBillCollection().add(bill);
                    bill.pleaseMove(targetTable.toJSON());
                    this.setCurrentBill();
                    deferred.resolve({success: true, bill: this.getCurrentBill(), target: targetTable});
                } else {
                    deferred.reject({message: i18n.msg("pos.table.item.refund.error.nullbill")});
                }
            }

            return deferred;
        },

        /**
         * Whether bills at this table can swith to other table
         * 1. 外卖桌不能转台
         * 2. 空桌不能转台
         * 3. 已经付款的不能转台
         * @returns {boolean}
         */
        canSwitch: function () {
            return (!this.isWebTable() && !this.isEmpty() && this.getCurrentBill().getBillItems().length > 0 && !this.getCurrentBill().isPaid());
        },
        /**
         * 订单是否可以转桌
         * @returns {boolean}
         */
        billCanSwitch: function (bill) {
            if (bill) {
                return (!this.isWebTable() && !this.isEmpty() && bill.getBillItems().length > 0 && !bill.isPaid());
            } else {
                return false;
            }
        },


        /*
         * 提交订单
         */
        submitBill: function () {
            DbRecorder.submit_recordTime = 0;
            var self = this, currentBill = self.getCurrentBill(), item,
                shouldSubmitTime = self.get("shouldSubmitTime") || 0, currentTime = new Date().getTime();

            if (self.get("status") === 'Paid') {
                POS.setTablePaidSum(POS.get("tablePaidSum") - 1);
            }
            self.set({status: 'Unpaid'});

            var isUnsubmittedBill = currentBill.getBillItems().length == 0;
            if (isUnsubmittedBill) {
                currentBill.set("uuid", uuid());
                console.log(new Date() + " assigned new UUID: " + currentBill.get("uuid"));
            }
            while (currentBill.getUnconfirmedItems().length > 0) {
                item = currentBill.getUnconfirmedItems().pop();
                item.confirm();
                currentBill.getBillItems().add(item);
            }
            if (currentTime - shouldSubmitTime > 1000) {
                self.set({shouldSubmitTime: new Date().getTime()});
            } else {
                console.log("submitting bill too quickly, ignored");
            }
        },

        /**
         * This method returns an array of Bill model that's within the specified time range.
         * If no time range is specified, then today's bill is returned.
         *
         * @param startTime
         * @param endTime
         * @returns {*|string}
         */
        getBills: function (startTime, endTime) {
            var start, end, bills;

            start = (!_.isUndefined(startTime) && startTime) ? startTime : new moment().startOf('day').toDate();
            end = (!_.isUndefined(endTime) && endTime) ? endTime : new Date();

            bills = _.filter(this.get("bills").models, function (bill) {
                return (start.getTime() <= bill.getCheckInTime()) && (end.getTime() > bill.getCheckInTime());
            });

            return _.isObject(bills) ? bills : [];
        },

        /**
         * This method returns a Backbone collection of all the bills on the table
         * @returns {*}
         */
        getBillCollection: function () {
            return this.get('bills');
        },

        /**
         * This method returns a Backbone collection of all the bills which should be displayed on the table
         * @returns {*}
         */
        getActiveBillCollection: function () {
            var self = this, bills = new BillCollection(), currentBill = self.getCurrentBill();
            if (self.getBillCollection() != null) {
                self.getBillCollection().forEach(function (bill) {
                    if (!bill.isCompleted() && !bill.isCanceled() && bill.getBillItems().length > 0) {
                        bills.add(bill);
                    }
                });
            }

            if (currentBill && !currentBill.isCompleted() && !currentBill.isCanceled() && currentBill.getBillItems().length > 0) {
                bills.add(currentBill);
            }
            return bills;
        },

        /**
         * This method returns a Backbone collection of all the bills which should be displayed on the table
         * @returns {*}
         */
        getCanMoveBillCollection: function () {
            var self = this, bills = new BillCollection(), currentBill = self.getCurrentBill();
            if (self.getBillCollection() != null) {
                self.getBillCollection().forEach(function (bill) {
                    if (!bill.isCompleted() && !bill.isCanceled() && !bill.isPaid() && bill.getBillItems().length > 0) {
                        bills.add(bill);
                    }
                });
            }

            if (currentBill && !currentBill.isCompleted() && !currentBill.isCanceled()  && !currentBill.isPaid() && currentBill.getBillItems().length > 0) {
                bills.add(currentBill);
            }
            return bills;
        },

        /**
         * @param bill
         * 如果传入Bill,将传入Bill设置为Current
         * 如果已经存在currentBill,并且未传入bill,依旧使用原来的currentBill
         * 否则创建新的currentBill
         */
        setCurrentBill: function (bill) {
            var currentBill = this.getCurrentBill();
            if (bill && bill.getBillItems().length > 0) {
                if (currentBill && currentBill.getBillItems().length > 0) {
                    this.getBillCollection().add(currentBill);
                }
                this.getBillCollection().add(bill);
                this.set('currentBill', bill);
            } else {
                this.createNewBill();
            }
        },
        getCurrentBill: function () {
            if (!this.get("currentBill")) {
                this.set("currentBill", new BillModel());
            }
            return this.get("currentBill");
        },

        getName: function () {
            return this.get("name");
        },
        getStatus: function () {
            var unpaid = this.getActiveBillCollection().any(function (bill) {
                return !bill.hasPaid()
            });
//                if ((this.getCurrentBill() == null || this.getCurrentBill().getBillItems().length <= 0) && this.get("status") == "Closed") {
//                    this.set("status", "Closed");
//                } else if ((this.getCurrentBill() == null || this.getCurrentBill().getBillItems().length <= 0) && this.get("status") != "Closed" && this.get("status") != "Paid") {
//                    this.set("status", "Empty");
//                } else if (this.getCurrentBill() != null && !(this.getCurrentBill().hasPaid())) {
//                    this.set("status", "Unpaid");
//                } else if (this.getCurrentBill() != null && this.getCurrentBill().hasPaid()) {
//                    this.set("status", "Paid");
//                }
            if (this.get("status") == "Closed" && this.isEmpty) {
                this.set("status", "Closed");
            } else if (this.isEmpty() && this.get("status") != "Closed") {
                this.set("status", "Empty");
            } else if (unpaid) {
                this.set("status", "Unpaid");
            } else {
                this.set("status", "Paid");
            }
            return this.get("status");
        },

        isWebTable: function () {
            return this.get('multiple');
        }
    });
};

let exportedValue = main(_, Backbone, BillModel, BillCollection, tables, i18n, DbRecorder, moment);
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/model/TableModel.js